let countdownWrapper = document.querySelector('.product__block-countdown');
if(!countdownWrapper) return;

const countdownElement = document.getElementById('countdown');
const translatedHours = countdownElement?.getAttribute('data-countdown-ts-hours');
const translatedMinutes = countdownElement?.getAttribute('data-countdown-ts-minutes');
const translatedSeconds = countdownElement?.getAttribute('data-countdown-ts-seconds');


// Function to get the current time in Denmark's time zone
function getCurrentDanishTime() {
  // Use Denmark's time zone identifier ('Europe/Copenhagen')
  const denmarkTimeZone = 'Europe/Copenhagen';
  const currentDate = new Date();
  
  // Create a date in Denmark's time zone
  const denmarkTime = new Date(currentDate.toLocaleString('en-US', { timeZone: denmarkTimeZone }));

  return denmarkTime;
}

// Function to check if today is a weekend (Saturday or Sunday)
function isWeekend() {
  const now = getCurrentDanishTime();
  const dayOfWeek = now.getDay(); // 0 = Sunday, 6 = Saturday

  return dayOfWeek === 0 || dayOfWeek === 6;
}

// Function to calculate time remaining until 14:00 Denmark time
function calculateTimeRemaining() {
  const now = getCurrentDanishTime();
  
  // Create a Date object for today at 14:00 in Denmark
  const endOfWorkDay = new Date(now);
  endOfWorkDay.setHours(14, 0, 0, 0); // Set the time to 14:00

  // If the current time is after 14:00, the shop is closed, so return 0
  if (now.getTime() > endOfWorkDay.getTime()) {
      return 0;
  }

  // Calculate the remaining time in milliseconds
  const timeRemaining = endOfWorkDay.getTime() - now.getTime();
  
  return timeRemaining;
}

// Function to format the time remaining in HHh MMm SSs
function formatTimeRemaining(milliseconds) {
  const hours = Math.floor(milliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((milliseconds % (1000 * 60)) / 1000);

  return `${hours}${translatedHours} ${minutes}${translatedMinutes} ${seconds}${translatedSeconds}`;
}

// Function to update the countdown timer
function updateCountdown() {
  const timeRemaining = calculateTimeRemaining();
  
  if (timeRemaining <= 0 || isWeekend()) {
    countdownWrapper.querySelector('.product__countdown--disabled')?.classList.add('show-delivery-message');
    countdownWrapper.querySelector('.product__countdown--active')?.classList.remove('show-delivery-message');
  } else {
      document.getElementById('countdown').innerText = formatTimeRemaining(timeRemaining);
      countdownWrapper.querySelector('.product__countdown--disabled')?.classList.remove('show-delivery-message');
      countdownWrapper.querySelector('.product__countdown--active')?.classList.add('show-delivery-message');
  }
}

// Call updateCountdown every second to keep the timer updated
setInterval(updateCountdown, 1000);
